import eFeedbackControllerTypes from './eControllerTypes';

export default {
  EFFCT_SPINNER: `${eFeedbackControllerTypes.EFCT_FORM}__spinner`,
  EFFCT_FILE_DROP: `${eFeedbackControllerTypes.EFCT_FORM}__file_drop`,
}
